import type { SerpBannerConfig } from '../types';

const mobileTourHotConfig = {
    fixed: [
        { id: 'adfox', cardIndex: 4 },
    ],
    queue: [
        { id: 'assistantSales', priority: 0, repeatMode: 'repeat' },
        { id: 'anniversary15',  priority: 1, repeatMode: 'repeat' },
        { id: 'appInstall',     priority: 2, repeatMode: 'repeat' },
        { id: 'learnDiscount', priority: 3, repeatMode: 'repeat' },
        { id: 'dreamTour',     priority: 4, repeatMode: 'repeat' },
        { id: 'hacks8',        priority: 5, repeatMode: 'repeat' },
        { id: 'subscribe',     priority: 6, repeatMode: 'once' },
        { id: 'tourIncludes',  priority: 7, repeatMode: 'repeat' },
    ],
} as const satisfies SerpBannerConfig;

export default mobileTourHotConfig;
